<template>
  <div class="team-grade">
    <el-table
      class="list"
      :data="list"
      height="calc(100vh - 60px - 59px - 60px - 60px)"
    >
      <el-table-column label="团队" prop="teamName"> </el-table-column>
      <el-table-column label="队长" prop="captainName" width="80">
      </el-table-column>
      <el-table-column label="分数" prop="score" align="center" width="60">
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="100" align="center">
        <template slot-scope="{ row }">
          <el-button size="mini" type="text" @click="handelGrade(row.teamId)"
            >评分</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <el-dialog title="评分" :visible.sync="show" center width="80%">
      <div class="content">
        <div class="top-row">
          <span>团队名称：{{ teamInfo.teamName }}</span>
          <span v-if="teamInfo.score || teamInfo.score == 0"
            >总分：<span style="color: #f56c6c; font-size: 24px">{{
              teamInfo.score
            }}</span></span
          >
        </div>

        <el-table
          class="list score-list"
          :data="scoreItemList"
          :span-method="objectSpanMethod"
          border
          height="50vh"
          style="width: 100%"
        >
          <el-table-column
            prop="postName"
            label="岗位"
            width="100"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="title"
            label="项目细则"
            width="165"
            align="center"
          >
          </el-table-column>
          <el-table-column prop="info" label="评价标准"> </el-table-column>
          <el-table-column
            prop="score"
            label="满分分值"
            width="55"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="teacherScore"
            label="教师评分"
            width="60"
            align="center"
          >
            <template slot-scope="scope">
              <span
                v-if="scope.row.teacherScore || scope.row.teacherScore == 0"
                >{{ scope.row.teacherScore }}</span
              >
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="enterpriseScore"
            label="企业导师评分"
            width="60"
            align="center"
          >
            <template slot-scope="scope">
              <span
                v-if="
                  scope.row.enterpriseScore || scope.row.enterpriseScore == 0
                "
                >{{ scope.row.enterpriseScore }}</span
              >
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="studentScore"
            label="学生评分均分"
            width="60"
            align="center"
          >
            <template slot-scope="scope">
              <span
                v-if="scope.row.studentScore || scope.row.studentScore == 0"
                >{{ scope.row.studentScore }}</span
              >
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column label="学生反馈/评分" width="170" align="center">
            <template slot-scope="scope">
              <template v-if="scope.row.systemComplete">
                <el-input-number
                  v-model="scope.row.result"
                  size="small"
                  :disabled="!teamInfo.isCaptain"
                  :controls="false"
                ></el-input-number>
              </template>
              <template v-else>
                <el-input-number
                  v-model="scope.row.myScore"
                  :min="0"
                  :max="scope.row.score"
                  :precision="1"
                  size="small"
                />
              </template>
            </template>
          </el-table-column>
          <el-table-column
            prop="itemScore"
            label="项目得分"
            width="70"
            align="center"
          >
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="show = false">取 消</el-button>
        <el-button type="primary" size="small" @click="handleSubmit"
          >提 交</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getGradeTeamList, getGradeInfo, writeItem } from "@/api/teamGrade";
export default {
  data() {
    return {
      list: [],
      teamInfo: {},
      show: false,
      idArr: [],
      idPos: 0,
    };
  },
  created() {
    this.getList();
  },
  computed: {
    scoreItemList() {
      if (this.teamInfo.itemScoreList) return this.teamInfo.itemScoreList;
    },
  },
  methods: {
    getList() {
      getGradeTeamList({
        classChapterId: this.$route.query.classChapterId,
      }).then((res) => {
        if (res.code == 0) {
          this.list = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    async handelGrade(teamId) {
      let res = await getGradeInfo({
        classChapterId: this.$route.query.classChapterId,
        teamId,
      });
      if (res.code == 0) {
        this.teamInfo = res.data;
        if (!this.teamInfo.score && this.teamInfo.score != 0)
          this.teamInfo.itemScoreList.forEach((item) => {
            item.myScore = item.score;
          });
        this.formatSpan();
        this.show = true;
      } else this.$message.error(res.msg);
    },
    formatSpan() {
      this.idArr = [];
      this.idPos = 0;
      this.scoreItemList.forEach((item, i) => {
        if (i == 0) {
          // 显示
          this.idArr.push(1);
          this.idPos = 0;
        } else {
          if (
            this.scoreItemList[i].postId == this.scoreItemList[i - 1].postId
          ) {
            // 相同则合并行数自加
            this.idArr[this.idPos] += 1;
            // 下一行不显示
            this.idArr.push(0);
          } else {
            // 不同则显示
            this.idArr.push(1);
            this.idPos = i;
          }
        }
      });
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        const _row = this.idArr[rowIndex];
        // 判断当前的 列是否需要显示
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
    },
    handleSubmit() {
      let itemScoreList = [];
      this.scoreItemList.forEach((item) => {
        itemScoreList.push({
          itemId: item.itemId,
          value: item.result,
          myScore: item.myScore,
        });
      });
      this.$confirm("确定要提交吗?", {
        type: "warning",
      })
        .then(() => {
          this.show = false;
          this.$loading.show();
          writeItem({
            classChapterId: this.$route.query.classChapterId,
            itemScoreList,
            teamId: this.teamInfo.teamId,
          }).then((res) => {
            this.$loading.hide();
            if (res.code == 0) {
              this.$message.success("提交成功");
              this.getList();
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="less" scoped>
.team-grade {
  .top-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    span {
      font-weight: bold;
      &.total-score {
        margin-left: 30px;
        color: #f56c6c;
        .score-text {
          font-size: 24px;
        }
      }
    }
  }
}
::v-deep .list {
  .is-leaf {
    color: #333;
    background-color: #f5f5f5;
  }
}
</style>